import { getCmsPageData } from '@/apis/apiCms';
import { ModuleInstance } from '@/apis/types/cms';
import _ from 'lodash';
import dynamic from 'next/dynamic';
import { Home_Page_Code } from '../../../../constants/cms';
const MentalClient = dynamic(() => import('./mentalClient'), { ssr: false });

interface Props {
  pageCode: string;
}

const getMentalModule = async (pageCode: string) => {
  const pageData = await getCmsPageData(pageCode);
  const mentalModule = _.flattenDeep(pageData?.data?.floors?.map((f) => f?.moduleInstances))?.find(
    (m) => m.moduleCode === 'platform-pc-mental',
  ) as ModuleInstance;
  return mentalModule;
};

export const Mental = async ({ pageCode }: Props) => {
  let mentalModule = await getMentalModule(pageCode);
  if (!mentalModule) {
    mentalModule = await getMentalModule(Home_Page_Code);
  }
  return <MentalClient mentalModule={mentalModule} pageCode={pageCode} />;
};
